import { render, staticRenderFns } from "./show.vue?vue&type=template&id=50d3ecd1&scoped=true"
import script from "./show.vue?vue&type=script&lang=ts"
export * from "./show.vue?vue&type=script&lang=ts"
import style0 from "./show.vue?vue&type=style&index=0&id=50d3ecd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3ecd1",
  null
  
)

export default component.exports